export default __webpack_public_path__ + "static/media/ceramol-iage-result-always-on-the-run.29f145c4.png";